// src/components/AddFirmDialog.js
import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';

const AddFirmDialog = ({ open, onClose, onSubmit, initialData }) => {
  // Estado para los campos del formulario de Firms
  const [firmName, setFirmName] = useState('');
  const [addressKey, setAddressKey] = useState('');
  const [route, setRoute] = useState('');

  useEffect(() => {
    if (open) {
      if (initialData) {
        setFirmName(initialData.firm_name || 'Firm');
        setAddressKey(initialData.address_key || '');
        setRoute(initialData.route || '');
      } else {
        setFirmName('Firm');
        setAddressKey('');
        setRoute('');
      }
    }
  }, [initialData, open]);
  const handleSubmit = () => {
    const newData = {
      firm_name: firmName,
      address_key: addressKey,
      route: parseInt(route, 10),
    };
    onSubmit(newData);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{initialData ? 'Edit Firm' : 'Add New Firm'}</DialogTitle>
      <DialogContent>
        <TextField autoFocus margin="dense" label="Firm Name" type="text" fullWidth variant="standard" value={firmName} onChange={(e) => setFirmName(e.target.value)} />
        <TextField margin="dense" label="Address Key (e.g., 8339 nw 64 st)" type="text" fullWidth variant="standard" value={addressKey} onChange={(e) => setAddressKey(e.target.value)} />
        <TextField margin="dense" label="Route" type="number" fullWidth variant="standard" value={route} onChange={(e) => setRoute(e.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddFirmDialog;
